import { createBrowserHistory } from 'history';

// 應用層共用的瀏覽器 history 實例。
// 原本由 index.js 建立並交給 connected-react-router；移除該套件後改為獨立模組匯出，
// 供入口 <Router> 使用，亦保留給未來元件外（如 saga / thunk）導航之用。
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const history = createBrowserHistory({ basename: baseUrl });

export default history;
